import { useState } from 'react';
import { ChevronDown, ChevronRight, CheckCircle, XCircle } from 'lucide-react';

/**
 * ActionResult - Collapsible display for action execution results
 * Shows summary when collapsed, full details when expanded
 */
export default function ActionResult({ action }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const { action: actionName, success, message, result } = action;

  return (
    <div className="bg-muted/50 dark:bg-muted/20 border border-border rounded-lg overflow-hidden">
      {/* Header - Always visible */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-start gap-2 p-3 hover:bg-muted/70 dark:hover:bg-muted/30 transition-colors text-left"
      >
        <div className="flex-shrink-0 mt-0.5">
          {isExpanded ? (
            <ChevronDown className="h-4 w-4 text-muted-foreground" />
          ) : (
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
          )}
        </div>

        <div className="flex-shrink-0 mt-0.5">
          {success ? (
            <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400" />
          ) : (
            <XCircle className="h-4 w-4 text-red-600 dark:text-red-400" />
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-2 flex-wrap">
            <span className="font-semibold text-sm">
              {actionName}
            </span>
            <span className="text-xs text-muted-foreground">
              {message || (success ? 'completed' : 'failed')}
            </span>
          </div>
        </div>
      </button>

      {/* Expanded details */}
      {isExpanded && result && (
        <div className="border-t border-border p-3 bg-muted/30 dark:bg-muted/10">
          <pre className="text-xs font-mono text-muted-foreground overflow-x-auto whitespace-pre-wrap break-words">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
